import { initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion } from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class Companion {}
//endregion
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
//region block: post-declaration
initMetadataForCompanion(Companion);
//endregion
//region block: init
Companion_instance = new Companion();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instance3fg086rwibfxp,
};
//endregion

//# sourceMappingURL=kotlin_com_hoolibit_hoolilib_marshalling.mjs.map
